import Image from 'next/image';
import React, { FC } from 'react';
import styled from 'styled-components';

import { windowSizeSelector } from '~/feature/media/windowSize.selector';
import { lessThan } from '~/lib/mediaQuery';
import { useAppSelector } from '~/store';

export interface ContestBannerProps {
  bannerSrc: string;
}

export const ContestBanner: FC<ContestBannerProps> = ({ bannerSrc }) => {
  const { size } = useAppSelector(windowSizeSelector);

  const imageWidth = size.width >= 1200 ? 1200 : size.width - 24;
  const imageHeight = Math.round(imageWidth * 0.3125);

  return (
    <SCContestBanner>
      <SCBanner
        width={imageWidth}
        height={imageHeight}
        src={bannerSrc}
        alt="баннер"
        loading="lazy"
      />
    </SCContestBanner>
  );
};

const SCContestBanner = styled.div`

`;

const SCBanner = styled(Image)`
  width: 100%;
  margin-bottom: 32px;
  background-color: hsla(0,0%,74.5%,.2);
  max-height: calc((100vw - 24px) * 0.3125);
  
  ${lessThan('container-width')} {
  max-height: calc(100vw * 0.3125);
  }
`;
